import React from 'react';


const TradesHeader = () => {

    return (
        <>
            <section className="trades-header" >
                <div className="icon"></div>
                <div className="description">Trade</div>
                <div className="verified">Create Task</div>
            </section>
        </>
    );
}


export default TradesHeader;

